// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___1lV_F","items":"styles__items___2l7wM","subitems":"styles__subitems___2mca5","title":"styles__title___2jQHY"};